import {useMemo, useState} from 'react';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';
import {localSearch} from '../../../library/searchFunctions';

export function useTimetableSearch(lectures: TTimetableItem[]) {
    const [searchQuery, setSearchQuery] = useState('');
    const visibleLectures = useMemo<TTimetableItem[]>(
        () => searchQuery.trim()
            ? localSearch(lectures, searchQuery.toLowerCase(), ['title', 'description'])
            : lectures,
        [lectures, searchQuery],
    );
    return {searchQuery, setSearchQuery, visibleLectures};
}
